import {
	GET_FEEDBACKS,
	GET_FEEDBACKS_SUCCESS,
	GET_FEEDBACKS_FAIL,
	GET_FEEDBACKS_RESET,
} from '../actions/getFeedbacksAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getFeedbacksReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_FEEDBACKS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_FEEDBACKS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_FEEDBACKS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_FEEDBACKS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getFeedbacksReducer;
